// TODO: remove this file after migration to @is/i18
import { register } from "@insightfulscience/smart-react/i18-formats/format";
import { midDate } from "@insightfulscience/i18/formats/date-formats";

register(midDate);
register(midDate, "MIDDATE");
